function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(46.27451%,74.901961%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 18 9 C 18 13.96875 13.96875 18 9 18 C 4.03125 18 0 13.96875 0 9 C 0 4.03125 4.03125 0 9 0 C 13.96875 0 18 4.03125 18 9 Z M 18 9 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.601562 7.199219 L 11.398438 7.199219 C 11.730469 7.199219 12 7.46875 12 7.800781 L 12 12.601562 C 12 12.929688 11.730469 13.199219 11.398438 13.199219 L 6.601562 13.199219 C 6.269531 13.199219 6 12.929688 6 12.601562 L 6 7.800781 C 6 7.46875 6.269531 7.199219 6.601562 7.199219 Z M 6.601562 7.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.199219 7.199219 C 4.53125 7.199219 4.800781 7.46875 4.800781 7.800781 L 4.800781 11.398438 C 4.800781 11.730469 4.53125 12 4.199219 12 C 3.867188 12 3.601562 11.730469 3.601562 11.398438 L 3.601562 7.800781 C 3.601562 7.46875 3.867188 7.199219 4.199219 7.199219 Z M 4.199219 7.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.800781 7.199219 C 14.132812 7.199219 14.398438 7.46875 14.398438 7.800781 L 14.398438 11.398438 C 14.398438 11.730469 14.132812 12 13.800781 12 C 13.46875 12 13.199219 11.730469 13.199219 11.398438 L 13.199219 7.800781 C 13.199219 7.46875 13.46875 7.199219 13.800781 7.199219 Z M 13.800781 7.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.199219 10.800781 C 10.53125 10.800781 10.800781 11.070312 10.800781 11.398438 L 10.800781 15 C 10.800781 15.332031 10.53125 15.601562 10.199219 15.601562 C 9.867188 15.601562 9.601562 15.332031 9.601562 15 L 9.601562 11.398438 C 9.601562 11.070312 9.867188 10.800781 10.199219 10.800781 Z M 10.199219 10.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.800781 10.800781 C 8.132812 10.800781 8.398438 11.070312 8.398438 11.398438 L 8.398438 15 C 8.398438 15.332031 8.132812 15.601562 7.800781 15.601562 C 7.46875 15.601562 7.199219 15.332031 7.199219 15 L 7.199219 11.398438 C 7.199219 11.070312 7.46875 10.800781 7.800781 10.800781 Z M 7.800781 10.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.773438 5.847656 C 11.917969 5.847656 12.023438 5.707031 11.996094 5.5625 C 11.8125 4.660156 11.253906 3.902344 10.5 3.464844 L 10.972656 2.582031 C 11.007812 2.523438 10.984375 2.449219 10.925781 2.414062 C 10.871094 2.382812 10.796875 2.402344 10.765625 2.464844 L 10.285156 3.351562 C 9.894531 3.164062 9.460938 3.058594 9 3.058594 C 8.539062 3.058594 8.105469 3.164062 7.714844 3.351562 L 7.234375 2.464844 C 7.203125 2.402344 7.128906 2.382812 7.074219 2.414062 C 7.015625 2.449219 6.992188 2.523438 7.027344 2.582031 L 7.5 3.464844 C 6.746094 3.902344 6.1875 4.660156 6.003906 5.5625 C 5.976562 5.707031 6.082031 5.847656 6.226562 5.847656 Z M 11.773438 5.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.398438 4.796875 C 10.253906 4.796875 10.140625 4.679688 10.140625 4.53125 C 10.140625 4.386719 10.253906 4.265625 10.398438 4.265625 C 10.539062 4.265625 10.65625 4.386719 10.65625 4.53125 C 10.65625 4.679688 10.539062 4.796875 10.398438 4.796875 Z M 10.398438 4.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.859375 4.53125 C 7.859375 4.679688 7.746094 4.796875 7.601562 4.796875 C 7.460938 4.796875 7.34375 4.679688 7.34375 4.53125 C 7.34375 4.386719 7.460938 4.265625 7.601562 4.265625 C 7.746094 4.265625 7.859375 4.386719 7.859375 4.53125 Z M 7.859375 4.53125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.d907289b055c48632e3a15f6e630350b.svg";
export { ForwardRef as ReactComponent };